




















import { Component, Inject, Vue } from "vue-property-decorator";
import StpSearch from "@/packages/albostp/StpSearch.vue";
import StpTable from "@/packages/albostp/StpTable.vue";
import { Page } from "yellowfin-ui-lib";
import { Anagrafica, AnagraficaRequest } from "@/data/models/anagrafica.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import packageInfo from "../../../package.json";

@Component({
  components: {
    StpSearch,
    StpTable,
  },
})
export default class AlboSTP extends Vue {
  @Inject("AnagraficaService")
  anagraficaService!: AnagraficaService;

  hideall = false;
  page: Page = new Page(20);
  data: Anagrafica[] = [];

  loading: boolean = false;

  searchparam: AnagraficaRequest = new AnagraficaRequest();

  constructor() {
    super();
  }

  onSearchChange(searchparam: AnagraficaRequest) {
    this.searchparam = searchparam;
    this.search();
  }

  search() {
    this.loading = true;
    const searchreq = this.anagraficaService.search(
      this.searchparam,
      this.page
    );
    const countreq = this.anagraficaService.searchCount(this.searchparam);
    Promise.all([searchreq, countreq])
      .then((results) => {
        this.data = results[0];
        this.page.setTotal(results[1].cnt);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  mounted() {
    if (!this.hideall) {
      (this.$refs.stpsearch as StpSearch).search();
    }
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);

    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    if (params.get("profileid")?.length) {
      this.hideall = true;
    }
  }
}
